<template>
  <v-snackbar v-model="erroReqModel" timeout="2500" color="error" top>{{
    msgError
  }}</v-snackbar>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  computed: {
    ...mapState("sistema", ["errorRequest", "msgError"]),
    erroReqModel: {
      get: function () {
        return this.errorRequest;
      },
      set: function (value) {
        this.setErrorRequest(value);
      },
    },
  },
  methods: {
    ...mapMutations("sistema", ["setErrorRequest"]),
  },
};
</script>

<style>
</style>